module.exports = __webpack_public_path__ + "media/vue/assets/images/promo-code/checked-ef3d5a21590492db53c652b74ba76d1c.svg";